module.exports = __webpack_public_path__ + "media/customizations/wolfranchlife/logo-c2c829da1f5460031aec90196c045bcf.png";